import { loadConfig } from './Configuration';

loadConfig().then(() => {
  import('./bootstrap');
}).catch((err) => {
  document.getElementById('root').innerHTML =
    '<div style="display:flex;justify-content:center;align-items:center;height:100vh;font-family:sans-serif;">' +
    '<div style="text-align:center;padding:20px;border:1px solid #dc3545;border-radius:8px;background:#fff5f5;">' +
    '<h3 style="color:#dc3545;margin:0 0 10px;">Application Failed to Start</h3>' +
    '<p style="color:#333;margin:0;">' + err.message + '</p>' +
    '</div></div>';
});
